import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { OrganizationsService } from '../services/organizations.service';
import { UsersService } from '../services/users.service';

/**
 * Utilisé pour intercepter les requêtes HTTP afin de gérer les reponses d'erreur.
 */
@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {
    constructor(
        private usersService: UsersService,
        private organizationsService: OrganizationsService,
        private router: Router,
        private toastr: ToastrService,
        private translate: TranslateService
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (sessionStorage.getItem('SessionId')) {
            const authReq = req.clone({
                headers: req.headers.append('SessionId', sessionStorage.getItem('SessionId')),
            });
            return next.handle(authReq).pipe(catchError((error: unknown) => this.handleError(error as HttpErrorResponse, req)));
        } else {
            return next.handle(req).pipe(catchError((error: unknown) => this.handleError(error as HttpErrorResponse, req)));
        }
    }

    /**
     * Gère une réponse en erreur.
     */
    public handleError(error: HttpErrorResponse, req: HttpRequest<any>) {
        if (error.status === 401) {
            this.usersService.removeCurrentUser();
            this.translate.get('Login.SessionExpired').subscribe((message: string) => {
                this.toastr.info(message);
                this.router.navigate(['/login']);
            });
        }
        // Vérifie si il ne faut pas utiliser les notifications globales
        const globalNotificationHeader = req.headers.get('global-notification');
        if (globalNotificationHeader !== null && globalNotificationHeader.toLowerCase() === 'false') {
            throwError(() => error);
        } else {
            if (error.status === 403) {
                if (!error.url.includes('api/token')) {
                    this.translate.get('NotRights').subscribe((message: string) => {
                        this.toastr.warning(message);
                    });
                }
            } else if (error.status === 409) {
                this.translate.get('Conflict').subscribe((message: string) => {
                    this.toastr.warning(message);
                });
            } else if (error.status === 423) {
                this.translate.get('AccountLocked').subscribe((message: string) => {
                    this.toastr.warning(message, '', { enableHtml: true });
                });
            } else if (error.status === 426) {
                this.translate.get('PasswordExpired').subscribe((message: string) => {
                    this.toastr.warning(message, '', { enableHtml: true });
                });
            } else if (error.status === 500) {
                this.translate.get('InternalServerError').subscribe((message: string) => {
                    this.toastr.warning(message);
                });
            } else if (error.status === 503) {
                this.translate.get('ServiceUnavailable').subscribe((message: string) => {
                    this.toastr.warning(message);
                });
            }
        }

        return throwError(error);
    }
}
